// extracted by mini-css-extract-plugin
export default {"waitContainer":"PnMHjf7C","text":"Rgma5323"};